let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("guUGa")).then(() => parcelRequire('2u29z'));